import { useContext } from "react";

import { ProjectResponse, ProjectUpdate } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";
import { ApiError } from "@nens/react-query-utils";

import { useUpdateProjectQueries } from "@/queries/query-project";
import { ProjectContext } from "@/stores/project-provider";

export const usePutProject = () => {
  const { id } = useContext(ProjectContext);
  const updateProjectQueries = useUpdateProjectQueries();

  return useMutationWithErrorHandler<ProjectResponse, ApiError, ProjectUpdate>(
    async (projectUpdate) => {
      const project = await getRanaApiV1().ProjectsApi.projectUpdate({
        projectId: id,
        projectUpdate,
      });

      updateProjectQueries(project.id, project);
      return project;
    },
    {}
  );
};
